import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { addAppSettings } from 'src/app/state/actions/app-settings.actions';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors';
import { AppSettings } from '../model/appSettings.model';
import { StringKeyValue } from '../model/stringKeyValue.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  appSettings: AppSettings;

  constructor(public activatedRoute: ActivatedRoute, private router: Router,private apiRef: ApiProviderService,
    private store: Store<AppState>) {
    this.store.select(selectAppSettings)
    .subscribe({
      next: state => {
        if(state) {
          this.appSettings = state;
        }
      }});
   }

  isEmbedModeActive(): boolean {
    const embedInUrl = (this.activatedRoute.snapshot.queryParamMap.get('Embed') === 'true') || false;
    if(embedInUrl && this.appSettings) {
      this.appSettings.embedMode = true;
      this.store.dispatch(
        addAppSettings(this.appSettings)
      );
    } else {
      return embedInUrl;
    }
    return this.appSettings?.embedMode;
  }

  navigateNewTab(url: string, target: string = '_blank'){
    url = this.checkUrlParams(url);
    const win = this.getWindowReference();

    win.open(url, target); //'/account/register-termsofuse'
  }

  navigate(url: string): void {
    const isModernTheme = this.isEmbedModeActive();

    const win = this.getWindowReference();
    //Adding Embed param in url
    if (isModernTheme) {
       const idx = url.indexOf('?');
       url = url + ((idx < 0) ? '?' : '&') + 'Embed=true';
    }
    win.location.href = url;
  }

  getHomePageUrl(): string{
    const isModernTheme = this.isEmbedModeActive();
    if(isModernTheme){
      return 'Welcome.aspx';
    }
      return'Default.aspx';
  }


  navigateLegacyPage(url: string){
    url = this.checkUrlParams(url);
    const win = this.getWindowReference();
    win.location.href = url;
  }

  navigateRoute(url: string, params?: Array<StringKeyValue>): void {
    const embedded = this.activatedRoute.snapshot.queryParamMap.get('inLegacyUI') === 'true' || false;
    const isModernTheme = this.isEmbedModeActive();

    if (embedded) {
      const win = window.parent;
      if(!params){
        params = new Array<StringKeyValue>();
      }

      if(isModernTheme && !params.find(kvp=>(kvp.Key==='Embed'))){
        const svp = new StringKeyValue();
        svp.Key = 'Embed';
        svp.Value = 'true';

        params.unshift(svp);
      }
      let paramString = '';
      params.forEach(kvp => {
        paramString += '&' +kvp.Key +'='+ kvp.Value;
      });
      url += paramString.replace('&','?');//replaces first instance of & only
        win.location.href = this.apiRef.vDir+ 'CommunityView/' + url;
    } else {
      url = '/'+url;
      if(params){
        this.router.navigate([url, params.map(kvp => kvp.Key + '=' + kvp.Value)]);
      } else {
        this.router.navigate([url]);
      }
    }
  }

  checkUrlParams(url: string): string{
    url = this.apiRef.vDir + url;
    const isModernTheme = this.isEmbedModeActive();

    //Adding Embed param in url
    if (isModernTheme) {
      const idx = url.indexOf('?');
      url = url + ((idx < 0) ? '?' : '&') + 'Embed=true';
    }

    if(this.activatedRoute.snapshot.queryParamMap.get('OpenCities')){
      url += `&OpenCities=true`;
    }

    return url;
  }

  getWindowReference(): Window{
    const embedded = this.activatedRoute.snapshot.queryParamMap.get('inLegacyUI') === 'true' || false;
    let win = this.apiRef.nativeWindow;
    if (embedded) {
      win = window.parent;
    }
    return win;
  }
}
